import { FileChartColumnIncreasing, type LucideIcon, Users } from 'lucide-react';

type NavigationSidebarRoute = '/practice-members' | '/reporting';

export type NavigationSidebarItem = {
    label: string;
    to: NavigationSidebarRoute;
    icon: LucideIcon;
};

export const navigationSidebarItems: NavigationSidebarItem[] = [
    {
        label: 'Practice Members',
        to: '/practice-members',
        icon: Users,
    },
    {
        // The design names this glyph "FileBarChart", lucide's retired alias for
        // FileChartColumnIncreasing — the bar heights in the frame are the increasing set.
        label: 'Reporting',
        to: '/reporting',
        icon: FileChartColumnIncreasing,
    },
];
